import { z } from "zod";

export const ADMIN_ROLE_VALUES = [
  "SuperAdmin", "OperationsAdmin", "FinanceAdmin", "SupportAgent",
  "ReliabilityEngineer", "SalesManager", "Analyst", "Auditor",
];

export const adminInviteSchema = z.object({
  fullName: z.string().trim().min(2, "Enter at least 2 characters").max(120, "Keep the name under 120 characters"),
  email: z.string().trim().toLowerCase().min(1, "Email is required").email("Enter a valid work email").max(254),
  role: z.enum(ADMIN_ROLE_VALUES, { errorMap: () => ({ message: "Select an operational role" }) }),
});
